import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { Constants } from '@utils/constants';
import { OrderWksQuickActionsComponent } from '@business/order-wks/order-wks-quick-actions/order-wks-quick-actions.component';
import { OrderWksStatusComponent } from '@business/order-wks/order-wks-status/order-wks-status.component';
import { AppUtils } from '@utils/app.utils';
import { EditOrderComponent } from '@component/edit-order/edit-order.component';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '@services/webFeeder/config.service';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { AuthServer } from '@services/auth-server.service';
import { GridOptions, GridApi } from 'ag-grid';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { CancelOrder } from '@model/webFeeder/message-cancel-order';
import { Quote } from '@model/webFeeder/quote.model';

@Component({
  selector: 'app-grid-order',
  templateUrl: './grid-order.component.html'
})
export class GridOrderComponent implements OnInit {

  @Output() gridReady = new EventEmitter<any>();
  @Input() filters = { quote: 'Todos', buyOrSell: 'Todos', state: 'Todos', };
  @Input() reducedColumns = false;
  @Input() showCancelAllBtn = false;
  @Input() set showStrategies(showStrategies: boolean) {
    if (showStrategies) {
      const columTemp = { headerName: 'OPERAÇÃO', field: 'orderStrategy', width: 110, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' };
      this.columnDefsOrders.push(columTemp);
    } else {
      this.columnDefsOrders = this.columnDefsOrders.filter(x => x.field !== 'orderStrategy');
      this.columnDefsOrdersAll = this.columnDefsOrdersAll.filter(x => x.field !== 'orderStrategy');
    }
  }
  private openStatus = ['Aberta', 'Nova', 'Parcialmente Executada', 'Editada', 'Cancelamento Pendente', 'Pendente', 'Edição Pendente', 'Suspensa'];
  private gridApiOrders: GridApi;
  tooltipCancelAll = Constants.ORDER_HISTORY_MSG010;
  gridOptionsOrders: GridOptions;
  thereAreRowsInTheGrid = false;
  columnDefsOrders = [];
  columnDefsOrdersAll = [
    { headerName: '', field: 'actions', width: 70, minWidth: 70, cellRendererFramework: OrderWksQuickActionsComponent, cellClass: 'btn-col', showInReducedMode: true },
    { headerName: 'DATA/HORA', field: 'transactTime', width: 115, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', comparator: this.sortArrayByDate, sort: 'desc' },
    { headerName: 'STATUS', field: 'state', width: 100, minWidth: 50, cellRendererFramework: OrderWksStatusComponent, cellClass: 'txt-left', headerClass: 'txt-left status-header', filter: 'agTextColumnFilter', showInReducedMode: true },
    { headerName: 'DIREÇÃO', field: 'side', width: 65, minWidth: 50, cellRenderer: this.renderDirection.bind(this), cellClass: '', showInReducedMode: true },
    { headerName: 'ATIVO', field: 'quote', width: 65, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left', filter: 'agTextColumnFilter' },
    { headerName: 'QTD OFERTADA', field: 'quantitySupplied', width: 70, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right' },
    { headerName: 'QTD EXEC', field: 'quantityExecuted', width: 70, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right' },
    { headerName: 'QTD REST', field: 'quantityRemaining', width: 70, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', showInReducedMode: true },
    { headerName: 'PREÇO', field: 'price', cellRenderer: this.priceStopFormatter.bind(this), width: 80, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', showInReducedMode: true },
    { headerName: 'PREÇO MÉDIO', field: 'priceAverage', cellRenderer: this.priceFormatter.bind(this), width: 80, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right' },
    { headerName: 'TIPO', field: 'type', width: 80, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'CONTA', field: 'account', width: 80, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'DISP', field: 'workingIndicator', width: 50, minWidth: 50, cellRenderer: this.renderDisp.bind(this), cellClass: '', headerClass: '' },
    { headerName: 'LOGIN', field: 'username', width: 100, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'VENCIMENTO', field: 'maturity', width: 115, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right' },
    { headerName: 'START/STOP', field: '', width: 80, minWidth: 50, cellRenderer: this.renderIsStartStop.bind(this), cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'MERCADO', field: 'mercado', width: 80, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'PORTA', field: '', width: 80, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'CANAL', field: 'applicationName', width: 80, minWidth: 50, cellClass: 'txt-left', headerClass: 'txt-left' },
    { headerName: 'PREÇO DISPARO LOSS', field: 'priceStop', width: 110, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', cellRenderer: this.priceFormatter.bind(this) },
    { headerName: 'PREÇO LIMITE LOSS', field: 'price', width: 110, minWidth: 50, cellRenderer: this.renderLimitLoss.bind(this), cellClass: 'txt-right', headerClass: 'txt-right' },
    { headerName: 'PREÇO DISPARO GAIN', field: 'priceStopGain', width: 110, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', cellRenderer: this.priceFormatter.bind(this) },
    { headerName: 'PREÇO LIMITE GAIN', field: 'price2', width: 110, minWidth: 50, cellClass: 'txt-right', headerClass: 'txt-right', cellRenderer: this.priceFormatter.bind(this), }
  ];

  constructor(
    private _dialog: MatDialog,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService,
    private _authServer: AuthServer
  ) { }

  ngOnInit() {
    if (!this.reducedColumns) {
      this.columnDefsOrders = [...this.columnDefsOrdersAll, ...this.columnDefsOrders];
    } else {
      this.columnDefsOrdersAll[0].width = 25;
      this.columnDefsOrdersAll[0].minWidth = 25;
      this.columnDefsOrders = this.columnDefsOrdersAll.filter(x => x.showInReducedMode);
    }
    this.setGridOptions();
  }

  rowsUpdated(event) {
    if (event) {
      this.thereAreRowsInTheGrid = event.lastRow !== -1;
    }
  }

  onGridReady(event) {
    this.gridReady.emit(event);
    this.gridApiOrders = event.api;
  }

  sortArrayByDate(date1, date2) {
    if (moment(date1, 'DD/MM/YYYY hh:mm:ssss').toDate().toISOString()
      > moment(date2, 'DD/MM/YYYY hh:mm:ssss').toDate().toISOString()) {
      return 1;
    }
    if (moment(date1, 'DD/MM/YYYY hh:mm:ssss').toDate().toISOString()
      < moment(date2, 'DD/MM/YYYY hh:mm:ssss').toDate().toISOString()) {
      return -1;
    }
    return 0;
  }

  renderDirection(param) {
    if (param.value) {
      const convertedValue = param.value.toLowerCase() === 'compra' ? 'C' : 'V';
      const directionClass = param.value.toLowerCase() === 'compra' ? 'buy-style' : 'sell-style';
      return '<span class="' + directionClass + '"> ' + convertedValue + '</span>';
    }
    return '';
  }

  renderDisp(param) {
    if (param.value) {
      const dispClass = param.value.toLowerCase() === 'n' ? 'disp-false' : 'disp-true';
      const dispValue = param.value.toLowerCase() === 'n' ? 'NÂO' : 'SIM';
      return '<span class="' + dispClass + '"> ' + dispValue + '</span>';
    }
    return '-';
  }

  renderIsStartStop(param) {
    let typeString = 'NÃO';
    if (param.data && param.data.typeCode) {
      if (param.data.typeCode === 4 || param.data.typeCode.toUpperCase() === 'S') {
        typeString = 'SIM';
      }
    }
    return '<span class=""> ' + typeString + ' </span>';
  }

  renderLimitLoss(param) {
    let limitLoss = '';
    if (param.data && param.data.price && (param.data.workingIndicator !== null || param.data.workingIndicator !== undefined)) {
      limitLoss = param.data.mercado === 'Bovespa' ? AppUtils.parseFloat(param.value) || 0 : AppUtils.convertBrCurrencyToNumber(param.value, '.') || 0;
    }
    return '<span class=""> ' + AppUtils.convertToCurrencyString(limitLoss, param.data.mercado === 'Bovespa' ? false : true) + '</span>';
  }

  priceFormatter(params) {
    if (params.value === undefined) {
      return '0,00';
    } else {
      const formatedValue = params.data.mercado === 'Bovespa' ? AppUtils.parseFloat(params.value) || 0 : AppUtils.convertBrCurrencyToNumber(params.value, '.') || 0;
      return '<span class="">' + AppUtils.convertToCurrencyString(formatedValue, params.data.mercado === 'Bovespa' ? false : true) + '</span>';
    }
  }

  priceStopFormatter(params) {
    if (params.value === undefined) {
      return '0,00';
    } else {
      params.value = params.data.type === TypeOrderEnum.STOP ? params.data.priceStop : params.value;
      const formatedValue = params.data.mercado === 'Bovespa' ? AppUtils.parseFloat(params.value) || 0 : AppUtils.convertBrCurrencyToNumber(params.value, '.') || 0;
      return '<span class="">' + AppUtils.convertToCurrencyString(formatedValue, params.data.mercado === 'Bovespa' ? false : true) + '</span>';
    }
  }

  isExternalFilterPresent() {
    let changeFilter = false;
    if (this.filters) {
      changeFilter = this.filters.quote === 'Todos' ? changeFilter : true;
      changeFilter = this.filters.buyOrSell === 'Todos' ? changeFilter : true;
      changeFilter = this.filters.state === 'Todos' ? changeFilter : true;
    }
    return changeFilter;
  }

  doesExternalFilterPass(node) {
    let row = node.data;
    if (!this.filters) {
      return row;
    }
    if (this.filters.state !== 'Todos') {
      row = node.data.state === this.filters.state ? row : null;
      if (this.openStatus.includes(node.data.state) && (this.filters.state === 'Aberta')) {
        row = node.data;
      }
    }
    if (this.filters.quote !== 'Todos') {
      row = node.data.quote === this.filters.quote ? row : null;
    }
    if (this.filters.buyOrSell !== 'Todos') {
      row = node.data.buyOrSell === this.filters.buyOrSell ? row : null;
    }
    return row;
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
  }

  setGridOptions() {
    this.gridOptionsOrders = <GridOptions>{
      headerHeight: 32,
      rowHeight: 25,
      enableColResize: true,
      defaultColDef: { sortable: true },
      columnDefs: this.columnDefsOrders,
      getRowNodeId: (data) => {
        return data.orderID;
      },
      localeText: { noRowsToShow: Constants.MSG_NO_DATA_TO_SHOW },
      context: { componentParent: this, scope: this },
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
    };
  }

  editOrder(params) {
    const modalOrders = this._dialog.open(EditOrderComponent, {
      panelClass: ['mat-modal-normal', 'order-wks'],
      width: params && params.typeCode === '4' ? '500px' : '772px'
    });
    modalOrders.componentInstance.dataOrder = params;
    modalOrders.componentInstance.close.subscribe(() => {
      modalOrders.close();
    });
  }

  cancelOrder(params, allOrders = false) {
    const modalOrders = this._dialog.open(NormalModalComponent, {
      data: { title: '', body: allOrders ? Constants.ORDER_HISTORY_MSG007 : Constants.ORDER_HISTORY_MSG002, isHistoryOrderWSO2: false },
      panelClass: 'mat-modal-normal',
    });
    if (modalOrders) {
      modalOrders.afterClosed().subscribe(result => {
        if (result) {
          if (allOrders) {
            this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.CANCEL_ALL_ORDER, this.filters.quote, false, null);
          } else {
            const cancelOrder: CancelOrder = this._dailyOrderService.transformCancelOrder(params);
            this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.CANCEL_ORDER, cancelOrder, allOrders);
          }
        }
      });
    }
  }

  replyOrder(params) {
    const modalOrders = this._dialog.open(NormalModalComponent, {
      data: { title: '', body: Constants.ORDER_HISTORY_MSG015, isHistoryOrderWSO2: false },
      panelClass: 'mat-modal-normal',
    });
    if (modalOrders) {
      modalOrders.afterClosed()
        .subscribe(result => {
          if (result) {
            this._authServer.iQuote.getQuote(params.quote)
              .subscribe((res: Quote) => {
                const model = this._dailyOrderService.convertDailyOrderToSendOrder(params);
                model.orderid = null;
                model.origclordid = null;
                model.loteDefault = res.loteDefault;
                this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, model);
              });
          }
        });
    }
  }

}
